type PropTypes = {
	loading?: boolean;
};
export default function AuthSubmit({ loading, ...props }: PropTypes) {
	if (loading)
		return (
			<div className="h-10 flex flex-1 justify-center items-start">
				<div className="rounded-md px-4 py-1 text-black w-full bg-[#C9FD05] opacity-50 font-medium flex justify-center">
					<span className="material-symbols-outlined animate-spin pointer-events-none">
						progress_activity
					</span>
				</div>
			</div>
		);
	return (
		<div className="h-10 flex flex-1 justify-center items-start">
			<button
				type="submit"
				className="bg-[#C9FD05] rounded-md px-4 py-1 text-black w-full hover:opacity-90 transition-opacity font-medium"
				{...props}
			>
				Submit
			</button>
		</div>
	);
}
